import "./Pruebas.css"
import axios from "axios";
import {useEffect, useState} from "react";

function Pruebas() {

    const [lista, setLista] = useState([]);
    const [listaLogued, setListaLogued] = useState([]);


    // Create the POST requuest
    useEffect(() => {
        var data ;
        axios.get('list_users/', {
            headers: {
                'Content-Type': 'application/json',
            },
            // withCredentials: true
        }).then(function (response){
            data = response.data
            setLista(data)

        }).catch(e=>{
            data = null;
            setListaLogued([])
        });
    },[]);


    useEffect(() => {
        // Replace 'your_token_here' with your actual Bearer token

        const token = localStorage.getItem('access_token')
        // console.log("token", token)
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        axios.get('list_users_auth/', config)
            .then(response => {
                // Handle the list of users received in the response
                // console.log('List of users:', response.data);
                setListaLogued(response.data)
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                // console.error('Error fetching users:', error);
            });
    },[]);



// asdf
    return (



            <div className="wrapperContent md:w-100 lg:w-100 xl:w-100 2xl:w-100 pt-20">
                <h2 className="sm:text-sm text-center mt-14">
                    Sobre nosotros
                </h2>
                <h1></h1><h1></h1><h1></h1><h1></h1><h1></h1>


                <h2>Lista de usuarios</h2>
                <div>
                    {lista ? (
                        <ul>
                            {lista.map((item) => (
                                <li key={item.id}>{item.name} - {item.email}</li>
                            ))}
                        </ul>
                    ) : (
                        <p>La lista está vacía.</p>
                    )}
                </div>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <h2>Lista de usuarios con logueo</h2>
                <div>
                    {listaLogued ? (
                        <ul>
                            {listaLogued.map((item) => (
                                <li key={item.id}>{item.name} - {item.email}</li>
                            ))}
                        </ul>
                    ) : (
                        <p>La lista está vacía.</p>
                    )}
                </div>






            </div>

    );
}

export default Pruebas;